<template>
  <div>
    <navTitle><div class="pageTitle">资讯详情</div></navTitle>
    <div class="friendsList">
      <div class="friendsItem flex">
        <img @click="$router.push(`/my/homePage?id=${detail.user_id}`)" :src="detail.avatar" class="avatar" />
        <div class="right flex-1 flex flex-column">
          <div class="flex flex-jus-between">
            <div>
              <div @click="$router.push(`/my/homePage?id=${detail.user_id}`)" class="name">{{detail.nickname}}</div>
              <div class="time">{{detail.time}}</div>
            </div>
            <div v-if="user_id != detail.user_id">
              <img @click="focus" v-if="detail.is_follow == 0" class="focus-icon" src="../../static/images/my/attention_yes.png">
              <img @click="focus" v-else class="focus-icon" src="../../static/images/my/attention_no.png">
            </div>
          </div>
          <div class="content">{{detail.brief}}</div>
          <div v-if="detail.type == 1" class="imgList flex flex-align-center flex-jus-between flex-wrap">
            <img @click="openImg(cIndex)" v-for="(cItem, cIndex) in detail.content" :key="cIndex" :src="cItem" alt="" />
          </div>
          <div v-if="detail.type == 2" class="imgList flex flex-align-center flex-jus-between flex-wrap">
            <videoItem :cover="detail.pic" :width="167" :height="111" :content="''" :videoSrc="detail.content"></videoItem>
          </div>
        </div>
      </div>
      <div class="flex flex-align-center flex-jus-between" style="margin: 20px 0">
        <div>
          <img class="good-avatar" :src="item.avatar" v-for="item in detail.likes_user" :key="item.user_id">
        </div>
        <div class="flex flex-align-center">
          <img @click="doLikes" class="good-icon" v-if="detail.is_likes == 1" src="../../static/images/index/good_yes.png">
          <img @click="doLikes" class="good-icon" v-if="detail.is_likes == 0" src="../../static/images/index/good.png">
          <span class="likes_num">{{detail.likes_num}}</span>
        </div>
      </div>
      <div class="title">
        评论 <span>({{detail.comment.total}})</span>
      </div>

      <div @click="replay(item)" v-for="item in detail.comment.data" :key="item.id" class="flex" style="margin-bottom: 20px">
        <div>
          <img class="discuss-avatar" :src="item.avatar">
        </div>
        <div>
          <div class="discuss-name">{{item.nickname}}</div>
          <div class="discuss-time">{{item.time}}</div>
          <div class="discuss-content">
            {{item.content}}
          </div>
          <div v-if="item.list.data.length" class="discuss-second">
            <div @click.stop="replayC(cItem)" v-for="cItem in item.list.data" :key="cItem.id" class="reply">
              {{cItem.from_nickname}}：<span>回复 {{cItem.to_nickname}}：</span> {{cItem.content}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom flex flex-align-center flex-jus-between">
      <div class="inp-box flex flex-align-center">
        <input v-model="content" type="text" :placeholder="inpPlaceholder">
      </div>
      <img @click="publish" class="send-icon" src="../../static/images/my/send.png" alt="">
    </div>
    <van-image-preview v-model="showImg" :images="imagesArr" :startPosition="startPosition">
    </van-image-preview>
  </div>
</template>

<script>
import navTitle from "@/views/components/navTitle.vue";
import videoItem from '@/views/components/videoItem.vue';
/* eslint-disable */
export default {
  components: {
    navTitle,
    videoItem
  },
  data() {
    return {
      id: '',
      user_id: '',
      detail: {
        comment: {
          data: []
        }
      },
      content: '',
      inpPlaceholder: '说点什么吧~',
      showImg: false,
			imagesArr: [],
      startPosition: 0
    };
  },
  created() {
    this.id = this.$route.query.id
    this.user_id = localStorage.getItem('user_id')
    this.getData()
  },
  mounted() {
    this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '友圈',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
  },
  methods: {
    getData() {
      this.$get('api/circle/getCiecleDetails', {
        circle_id: this.id
      }).then(res => {
        this.detail = res.data
      })
    },
    focus() {
      this.$post('api/circle/userFollow', {to_id:this.detail.user_id}).then(res => {
				if (this.detail.is_follow == 1) {
					this.$toast('已取关')
          this.detail.is_follow = 0
				} else {
					this.$toast('关注成功')
          this.detail.is_follow = 1
				}
			})
    },
    doLikes() {
      let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
        return
			}
			this.$post('api/actile/doLikes', {
				type: 2,
				article_id: this.id
			}).then(() => {
        this.getData()
      })
		},
    replay(data) {
      this.pid = data.id
      this.to_id = data.from_id
      this.inpPlaceholder = '回复'+data.nickname+'：'
    },
    replayC(data) {
      this.pid = data.pid
      this.to_id = data.from_id
      this.inpPlaceholder = '回复'+data.from_nickname+'：'
    },
    publish() {
      let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
        return
			}
      if (!this.content) {
        this.$toast('请输入内容')
        return
      }
      this.$post('api/circle/commentPush', {
        circle_id: this.id,
        type: 1,
        content: this.content,
        pid: this.pid,
        to_id: this.to_id
      }).then(() => {
        this.$toast('评论成功')
        this.content = ''
        this.pid = ''
        this.to_id = ''
        this.inpPlaceholder = '说点什么吧~'
        this.getData()
      })
    },
    openImg() {
      this.imagesArr = this.detail.content
      this.showImg = true
      this.startPosition = index
    }
  },
};
</script>

<style scoped lang="stylus">
.pageTitle {
  width: 100%;
  text-align: center;
  font-size: 34px;
  font-weight: 500;
  color: #FFFFFF;
}
.focus-icon {
  width 132px
  height 54px
}
.good-icon {
  width 32px
  height 32px
}
.likes_num {
  font-size 32px
  color #DE113C
  margin-left 10px
  line-height 36px
}
.good-avatar {
  width 60px
  height 60px
  border-radius 50%
  margin-left -20px
}
.good-avatar:first-child {
  margin-left 0
}

.title {
  font-size 32px
  color #000
  font-weight bold
  margin-bottom 28px
  span {
    font-size 26px
  }
}

.discuss-avatar {
  width 82px
  height 82px
  border-radius 50%
  margin-right 16px
}
.discuss-name {
  font-size 30px
  color #000
  line-height 42rpx
  font-weight bold
  margin-bottom 8px
}
.discuss-time {
  font-size 26px
  color #9E9E9E
  line-height 36px
  margin-bottom 14px
}
.discuss-content {
  font-size 26px
  color #000
  line-height 40px
  margin-bottom 32px
  width 592px
}
.discuss-second {
  background #f8f8f8
  width 592px
  border-radius 10px
  padding 24px 24px 0
}
.reply {
  font-size 26px
  color #000
  line-height 36px
  padding-bottom 24px
}
.reply span {
  color #818181
}

.friendsList
	padding 0 30px 100px
	.friendsItem
		padding-top 44px
		.avatar
			width 84px
			height 84px
			border-radius 50%
		.name
			font-size 28px
			font-weight bold
			color #000000
		.time
			margin-top 8px
			font-size 22px
			color #979797
		.content
			margin-top 24px
			margin-bottom 28px
			width 100%
			font-size 26px
			color #000000
		.imgList
			img
				width 186px
				height 186px
        object-fit cover
				border-radius 20px
				margin-bottom 10px
		.imgList:after
			content ''
			display inline-block
			width 186px
		.right
			margin-left 24px
		.infoStatus
			margin-top 40px
			margin-bottom 40px
			font-size 26px
			color #000000
			.icon
				width 32px
				height 32px
				margin-right 8px
.bottom
  position fixed
  padding 0 30px
  bottom 0
  left 0
  height 126px
  width 100%
  background #fff
  box-shadow 0px -6px 12px rgba(0, 0, 0, 0.06)
.inp-box
  height 74px
  width 604px
  background #F4F4F4
  border-radius 74px
  overflow hidden
  input
    height 74px
    font-size 26px
    width 604px
    background transparent
    padding 0 28px
.send-icon
  width 46px
  height 48px
</style>
